import Books from "./images/Books.webp"
import Electronics from "./images/Electronics.webp"
import Clothing from "./images/Clothing.webp"
import RealEstate from "./images/Real Estate.webp"
import Vehicles from "./images/Vehicles.webp"
import Rocket from "./images/Rocket.webp"

const Products = () => {
  const productsArray = []
  for(let i = 0; i< 20; i++)
  {
   productsArray.push({
     id: i + 160,
     image:`${Rocket}`,
     title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
     description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
  Outer cover has some corner, edge, surface wear.
  There may be other wear consistent with being previously owned and considering its age, use.
  Please see pictures for condition.
  The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
  We are selling them as is and used unless state
  
  We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
  Occasionally the Very old Books do have a musty smell due to age and storage.
  
  Also we take great pride in our packaging of the product.
  
  No Stock Photographs, we take all our own pictures.`,
     price:20,
     tag:"Featured Collection",
   condition: "New",
  itemLocation: "Argentina, Besmola",
  shipping: "Worldwide",
  shippingCost: "Free",
  returns: "Seller Accepts Returns",
  paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
  for(let i = 0; i< 20; i++)
  {
    productsArray.push({
      id: i + 1160,
      image:`${Rocket}`,
      title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
      description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
Outer cover has some corner, edge, surface wear.
There may be other wear consistent with being previously owned and considering its age, use.
Please see pictures for condition.
The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
We are selling them as is and used unless state

We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
Occasionally the Very old Books do have a musty smell due to age and storage.

Also we take great pride in our packaging of the product.

No Stock Photographs, we take all our own pictures.`,
      price:20,
      tag:"Best Selling",
    condition: "New",
itemLocation: "Argentina, Besmola",
      shipping: "Worldwide",
shippingCost: "Free",
returns: "Seller Accepts Returns",
paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
  for(let i = 0; i< 20; i++)
  {
    productsArray.push({
      id: i + 601,
      image:`${Rocket}`,
      title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
      description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
Outer cover has some corner, edge, surface wear.
There may be other wear consistent with being previously owned and considering its age, use.
Please see pictures for condition.
The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
We are selling them as is and used unless state

We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
Occasionally the Very old Books do have a musty smell due to age and storage.

Also we take great pride in our packaging of the product.

No Stock Photographs, we take all our own pictures.`,
      price:20,
      tag:"Most Recent",
    condition: "New",
itemLocation: "Argentina, Besmola",
      shipping: "Worldwide",
shippingCost: "Free",
returns: "Seller Accepts Returns",
paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
  for(let i = 0; i< 20; i++)
  {
    productsArray.push({
      id: i ,
      image:`${Clothing}`,
      title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
      description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
Outer cover has some corner, edge, surface wear.
There may be other wear consistent with being previously owned and considering its age, use.
Please see pictures for condition.
The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
We are selling them as is and used unless state

We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
Occasionally the Very old Books do have a musty smell due to age and storage.

Also we take great pride in our packaging of the product.

No Stock Photographs, we take all our own pictures.`,
      price:20,
      tag:"clothing",
    condition: "New",
itemLocation: "Argentina, Besmola",
      shipping: "Worldwide",
shippingCost: "Free",
returns: "Seller Accepts Returns",
paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
  for(let i = 0; i< 20; i++)
  {
    productsArray.push({
      id: i + 20,
      image:`${RealEstate}`,
      title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
      description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
Outer cover has some corner, edge, surface wear.
There may be other wear consistent with being previously owned and considering its age, use.
Please see pictures for condition.
The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
We are selling them as is and used unless state

We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
Occasionally the Very old Books do have a musty smell due to age and storage.

Also we take great pride in our packaging of the product.

No Stock Photographs, we take all our own pictures.`,
      price:20,
      tag:"realEstate",
    condition: "New",
itemLocation: "Argentina, Besmola",
      shipping: "Worldwide",
shippingCost: "Free",
returns: "Seller Accepts Returns",
paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
  for(let i = 0; i< 20; i++)
  {
    productsArray.push({
      id: i + 40,
      image:`${Vehicles}`,
      title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
      description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
Outer cover has some corner, edge, surface wear.
There may be other wear consistent with being previously owned and considering its age, use.
Please see pictures for condition.
The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
We are selling them as is and used unless state

We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
Occasionally the Very old Books do have a musty smell due to age and storage.

Also we take great pride in our packaging of the product.

No Stock Photographs, we take all our own pictures.`,
      price:20,
      tag:"vehicles",
    condition: "New",
itemLocation: "Argentina, Besmola",
      shipping: "Worldwide",
shippingCost: "Free",
returns: "Seller Accepts Returns",
paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
  for(let i = 0; i< 20; i++)
  {
    productsArray.push({
      id: i + 60,
      image:`${Electronics}`,
      title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
      description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
Outer cover has some corner, edge, surface wear.
There may be other wear consistent with being previously owned and considering its age, use.
Please see pictures for condition.
The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
We are selling them as is and used unless state

We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
Occasionally the Very old Books do have a musty smell due to age and storage.

Also we take great pride in our packaging of the product.

No Stock Photographs, we take all our own pictures.`,
      price:20,
      tag:"electronics",
    condition: "New",
itemLocation: "Argentina, Besmola",
      shipping: "Worldwide",
shippingCost: "Free",
returns: "Seller Accepts Returns",
paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
 
  for(let i = 0; i< 20; i++)
  {
    productsArray.push({
      id: i + 80,
      image:`${Books}`,
      title:"Rocket Toy With red Wings and Smiley Face, Cotton, Pads, Washable, ",
      description: `This book has been previously owned and shows wear due to age, usage, also could have stains, foxing, scratches, creases, scuff marks to cover and pages.
Outer cover has some corner, edge, surface wear.
There may be other wear consistent with being previously owned and considering its age, use.
Please see pictures for condition.
The Majority of our books are used. However we do at times sell brand new books, and books that are in excellent condition. We will let you know in the condition section about these books. We try to take note of the condition of each book so please look at the pictures for any damage that the book might have, because we can and do miss some of the damage.
We are selling them as is and used unless state

We can ship internationally, however the cost in doing that will be extra and at times quite expensive. So if you are interested, please contact us before bidding or buying and we will let you know what shipping costs are
Occasionally the Very old Books do have a musty smell due to age and storage.

Also we take great pride in our packaging of the product.

No Stock Photographs, we take all our own pictures.`,
      price:20,
      tag:"books",
    condition: "New",
itemLocation: "Argentina, Besmola",
      shipping: "Worldwide",
shippingCost: "Free",
returns: "Seller Accepts Returns",
paymanets: "Paypal, Visa, Master, Amex, Maestro, Discover"
    })
  }
  console.log(productsArray.map(product => product.tag))
  return productsArray
}
const ProductsGenrateor = Products()
export default ProductsGenrateor